import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateWarehouseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateWarehouse = createAsyncThunk('updateWarehouse', async (payload) => {
  return await updateWarehouseApi(payload);
});

const updateWarehouseSlice = createSlice({
  name: 'updateWarehouse', // Unique Name
  initialState,
  reducers: {
    updateWarehouseReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateWarehouse.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateWarehouse.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateWarehouse.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateWarehouseReset } = updateWarehouseSlice.actions;

export default updateWarehouseSlice.reducer;
